import {requestStorePermissions, can} from './permission-methods';

export const StorePermission = {
	VIEW: 'VIEW',
	DISABLE: 'DISABLE',
	ENABLE: 'ENABLE',
	DELETE: 'DELETE',
	EDIT_BASIC: 'EDIT_BASIC',
	EDIT_OPENING_HOURS: 'EDIT_OPENING_HOURS',
	EDIT_LOGO: 'EDIT_LOGO',
	EDIT_IMAGES: 'EDIT_IMAGES',
	EDIT_SOCIAL_MEDIA: 'EDIT_SOCIAL_MEDIA',
	EDIT_PARKING: 'EDIT_PARKING',
	EDIT_PAYMENT_METHODS: 'EDIT_PAYMENT_METHODS',
	EDIT_BRANDS: 'EDIT_BRANDS',
	EDIT_GASTRO_BASIC: 'EDIT_GASTRO_BASIC',
	EDIT_GASTRO_MENU: 'EDIT_GASTRO_MENU',
	EDIT_STADTGELD: 'EDIT_STADTGELD',
	EDIT_ARTICLES: 'EDIT_ARTICLES',
	VIEW_USERS: 'VIEW_USERS',
	ADD_USER: 'ADD_USER',
	REMOVE_USER: 'REMOVE_USER',
	CHANGE_USER_ROLE: 'CHANGE_USER_ROLE',
	CHANGE_OWNER: 'CHANGE_OWNER',
	VIEW_ROLES: 'VIEW_ROLES',
	CREATE_ROLE: 'CREATE_ROLE',
	EDIT_ROLE: 'EDIT_ROLE',
	DELETE_ROLE: 'DELETE_ROLE',
	ASSIGN_ROLE: 'ASSIGN_ROLE',
	VIEW_ORDER_SPLIT: 'VIEW_ORDER_SPLIT',
	VIEW_SALES_STORES: 'VIEW_SALES_STORES',
	EDIT_SALES_SETTINGS: 'EDIT_SALES_SETTINGS',
	VIEW_SALES: 'VIEW_SALES',
	VIEW_RESERVATIONS: 'VIEW_RESERVATIONS',
	UPDATE_RESERVATION_STATUS: 'UPDATE_RESERVATION_STATUS',
	EDIT_RESERVATION_SETTINGS: 'EDIT_RESERVATION_SETTINGS',
	VIEW_APPOINTMENT_REQUESTS: 'VIEW_APPOINTMENT_REQUESTS',
	EDIT_APPOINTMENT_REQUEST_SETTINGS: 'EDIT_APPOINTMENT_REQUEST_SETTINGS',
	ACCEPT_APPOINTMENT_REQUEST: 'ACCEPT_APPOINTMENT_REQUEST',
	REJECT_APPOINTMENT_REQUEST: 'REJECT_APPOINTMENT_REQUEST',
	VIEW_REPORTS: 'VIEW_REPORTS',
	VIEW_ARTICLES: 'VIEW_ARTICLES',
	ADD_ARTICLE: 'ADD_ARTICLE',
	EDIT_STOCK_ITEMS: 'EDIT_STOCK_ITEMS',
	VIEW_SELECTED_OFFER_CAMPAIGNS: 'VIEW_SELECTED_OFFER_CAMPAIGNS',
	CREATE_SELECTED_OFFER_CAMPAIGNS: 'CREATE_SELECTED_OFFER_CAMPAIGNS',
	EDIT_SELECTED_OFFER_CAMPAIGNS: 'EDIT_SELECTED_OFFER_CAMPAIGNS',
	DELETE_SELECTED_OFFER_CAMPAIGNS: 'DELETE_SELECTED_OFFER_CAMPAIGNS',
	USE_EMBEDDABLES_EDITOR: 'USE_EMBEDDABLES_EDITOR',
	VIEW_EMBEDDABLE_TEMPLATES: 'VIEW_EMBEDDABLE_TEMPLATES',
	CREATE_EMBEDDABLE_TEMPLATES: 'CREATE_EMBEDDABLE_TEMPLATES',
	EDIT_EMBEDDABLE_TEMPLATES: 'EDIT_EMBEDDABLE_TEMPLATES',
	DELETE_EMBEDDABLE_TEMPLATES: 'DELETE_EMBEDDABLE_TEMPLATES',
	ENABLE_INTEGRATION: 'ENABLE_INTEGRATION',
	DISABLE_INTEGRATION: 'DISABLE_INTEGRATION',
	VIEW_ORDERS: 'VIEW_ORDERS',
	PROCESS_ORDERS: 'PROCESS_ORDERS',
	REFUND_ORDERS: 'REFUND_ORDERS'
};

export const Permission = {
	ACCESS_ADMIN_PANEL: 'ACCESS_ADMIN_PANEL',
	VIEW_ALL_USER_REQUESTS: 'VIEW_ALL_USER_REQUESTS',
	CREATE_USER_REQUESTS: 'CREATE_USER_REQUESTS',
	EDIT_USER_REQUESTS: 'EDIT_USER_REQUESTS',
	CREATE_STORE: 'CREATE_STORE',
	VIEW_ALL_STORES: 'VIEW_ALL_STORES',
	EDIT_ALL_STORES: 'EDIT_ALL_STORES',
	CHANGE_ALL_STORES_STATUS: 'CHANGE_ALL_STORES_STATUS',
	ACT_AS_USER: 'ACT_AS_USER',
	OWN_STORES: 'OWN_STORES',
	VIEW_ALL_RESERVATIONS: 'VIEW_ALL_RESERVATIONS',
	EDIT_USERS: 'EDIT_USERS',
	INVITE_USERS: 'INVITE_USERS',
	EDIT_USER_INVITATIONS: 'EDIT_USER_INVITATIONS',
	VIEW_ALL_USERS: 'VIEW_ALL_USERS',
	MORPH_TO_USER: 'MORPH_TO_USER',
	ASSIGN_USER_ROLE: 'ASSIGN_USER_ROLE',
	VIEW_ALL_AGENCIES: 'VIEW_ALL_AGENCIES',
	EDIT_AGENCY: 'EDIT_AGENCY',
	MORPH_TO_AGENCY: 'MORPH_TO_AGENCY',
	CREATE_AGENCY: 'CREATE_AGENCY',
	DELETE_AGENCY: 'DELETE_AGENCY',
	REMOVE_USER_FROM_ALL_STORES: 'REMOVE_USER_FROM_ALL_STORES',
	VIEW_OWN_SUBSCRIPTIONS: 'VIEW_OWN_SUBSCRIPTIONS',
	VIEW_BRANDS: 'VIEW_BRANDS',
	CREATE_BRANDS: 'CREATE_BRANDS',
	UPDATE_BRANDS: 'UPDATE_BRANDS',
	DELETE_BRANDS: 'DELETE_BRANDS',
	OWN_BRANDS: 'OWN_BRANDS',
	SUBMIT_BRAND_PRODUCTS: 'SUBMIT_BRAND_PRODUCTS',
	LOCAL_TREE_ADMIN: 'LOCAL_TREE_ADMIN',
	LOCAL_TREE_USER: 'LOCAL_TREE_USER',
	EDIT_CONNECTORS: 'EDIT_CONNECTORS',
	VIEW_ALL_REPORTS: 'VIEW_ALL_REPORTS',
	BLACKLIST_EMAIL: 'BLACKLIST_EMAIL',
	DELETE_USERS: 'DELETE_USERS',
	CHANGE_ANY_USER_PASSWORD: 'CHANGE_ANY_USER_PASSWORD',
	EDIT_PLANS: 'EDIT_PLANS',
	VIEW_USER_REPORTS: 'VIEW_USER_REPORTS',
	EDIT_USER_REPORTS: 'EDIT_USER_REPORTS',
	DELETE_ALL_STORES: 'DELETE_ALL_STORES',
	VIEW_USER_ROLES: 'VIEW_USER_ROLES',
	ASSIGN_USER_TO_AGENCY: 'ASSIGN_USER_TO_AGENCY',
	VIEW_REPORTS: 'VIEW_REPORTS',
	VIEW_YOUBUYDA_SALES_REPORTS: 'VIEW_YOUBUYDA_SALES_REPORTS',
	VIEW_ALL_FTP_ACCOUNTS: 'VIEW_ALL_FTP_ACCOUNTS',
	DELETE_FTP_ACCOUNT: 'DELETE_FTP_ACCOUNT',
	CREATE_FTP_ACCOUNT: 'CREATE_FTP_ACCOUNT',
	EDIT_ARTICLE_UPDATE_REQUEST: 'EDIT_ARTICLE_UPDATE_REQUEST',
	VIEW_ALL_SUBSCRIPTIONS: 'VIEW_ALL_SUBSCRIPTIONS',
	EDIT_ALL_SUBSCRIPTIONS: 'EDIT_ALL_SUBSCRIPTIONS',
	CANCEL_ALL_SUBSCRIPTIONS: 'CANCEL_ALL_SUBSCRIPTIONS',
	CREATE_SUBSCRIPTION_COUPONS: 'CREATE_SUBSCRIPTION_COUPONS',
	VIEW_SUBSCRIPTION_COUPONS: 'VIEW_SUBSCRIPTION_COUPONS',
	DELETE_SUBSCRIPTION_COUPONS: 'DELETE_SUBSCRIPTION_COUPONS',
	CREATE_SUBSCRIPTION_FEATURES: 'CREATE_SUBSCRIPTION_FEATURES',
	VIEW_SUBSCRIPTION_FEATURES: 'VIEW_SUBSCRIPTION_FEATURES',
	EDIT_SUBSCRIPTION_FEATURES: 'EDIT_SUBSCRIPTION_FEATURES',
	DELETE_SUBSCRIPTION_FEATURES: 'DELETE_SUBSCRIPTION_FEATURES',
	CREATE_SUBSCRIPTION_BUNDLES: 'CREATE_SUBSCRIPTION_BUNDLES',
	VIEW_SUBSCRIPTION_BUNDLES: 'VIEW_SUBSCRIPTION_BUNDLES',
	EDIT_SUBSCRIPTION_BUNDLES: 'EDIT_SUBSCRIPTION_BUNDLES',
	DELETE_SUBSCRIPTION_BUNDLES: 'DELETE_SUBSCRIPTION_BUNDLES',
	VIEW_SUBSCRIPTION_PRICINGS: 'VIEW_SUBSCRIPTION_PRICINGS',
	CREATE_SUBSCRIPTION_PRICINGS: 'CREATE_SUBSCRIPTION_PRICINGS',
	EDIT_SUBSCRIPTION_PRICINGS: 'EDIT_SUBSCRIPTION_PRICINGS',
	DELETE_SUBSCRIPTION_PRICINGS: 'DELETE_SUBSCRIPTION_PRICINGS',
	VIEW_ALL_ORDERS: 'VIEW_ALL_ORDERS',
	HAVE_UNLIMITED_STORES: 'HAVE_UNLIMITED_STORES',
	CRAWLER: 'CRAWLER',
	VIEW_SERVER_STATS: 'VIEW_SERVER_STATS',
	EDIT_ALL_AGENCIES: 'EDIT_ALL_AGENCIES',
	SELL_PRODUCTS: 'SELL_PRODUCTS',
	CHANGE_STORE_OWNER: 'CHANGE_STORE_OWNER',
	ADD_STORE_USER: 'ADD_STORE_USER',
	REMOVE_STORE_USER: 'REMOVE_STORE_USER',
	CHANGE_USER_STORE_ROLE: 'CHANGE_USER_STORE_ROLE',
	VIEW_ALL_AGENCY_USERS: 'VIEW_ALL_AGENCY_USERS',
	VIEW_STORE_USERS: 'VIEW_STORE_USERS',
	VIEW_AGENCY_STORES: 'VIEW_AGENCY_STORES',
	EDIT_AGENCY_STORES: 'EDIT_AGENCY_STORES',
	VIEW_AGENCY_USERS: 'VIEW_AGENCY_USERS',
	EDIT_AGENCY_USERS: 'EDIT_AGENCY_USERS',
	VIEW_AGENCY_USER_REQUESTS: 'VIEW_AGENCY_USER_REQUESTS',
	EDIT_AGENCY_USER_REQUESTS: 'EDIT_AGENCY_USER_REQUESTS'
};

export const PermissionsMixin = {
    data() {
        return {
			Permission: {
            	ACCESS_ADMIN_PANEL: false,
				VIEW_ALL_USER_REQUESTS: false,
				CREATE_USER_REQUESTS: false,
				EDIT_USER_REQUESTS: false,
				CREATE_STORE: false,
				VIEW_ALL_STORES: false,
				EDIT_ALL_STORES: false,
				CHANGE_ALL_STORES_STATUS: false,
				ACT_AS_USER: false,
				OWN_STORES: false,
				VIEW_ALL_RESERVATIONS: false,
				EDIT_USERS: false,
				INVITE_USERS: false,
				EDIT_USER_INVITATIONS: false,
				VIEW_ALL_USERS: false,
				MORPH_TO_USER: false,
				ASSIGN_USER_ROLE: false,
				VIEW_ALL_AGENCIES: false,
				EDIT_AGENCY: false,
				MORPH_TO_AGENCY: false,
				CREATE_AGENCY: false,
				DELETE_AGENCY: false,
				REMOVE_USER_FROM_ALL_STORES: false,
				VIEW_OWN_SUBSCRIPTIONS: false,
				VIEW_BRANDS: false,
				CREATE_BRANDS: false,
				UPDATE_BRANDS: false,
				DELETE_BRANDS: false,
				OWN_BRANDS: false,
				SUBMIT_BRAND_PRODUCTS: false,
				LOCAL_TREE_ADMIN: false,
				LOCAL_TREE_USER: false,
				EDIT_CONNECTORS: false,
				VIEW_ALL_REPORTS: false,
				BLACKLIST_EMAIL: false,
				DELETE_USERS: false,
				CHANGE_ANY_USER_PASSWORD: false,
				EDIT_PLANS: false,
				VIEW_USER_REPORTS: false,
				EDIT_USER_REPORTS: false,
				DELETE_ALL_STORES: false,
				VIEW_USER_ROLES: false,
				ASSIGN_USER_TO_AGENCY: false,
				VIEW_REPORTS: false,
				VIEW_YOUBUYDA_SALES_REPORTS: false,
				VIEW_ALL_FTP_ACCOUNTS: false,
				DELETE_FTP_ACCOUNT: false,
				CREATE_FTP_ACCOUNT: false,
				EDIT_ARTICLE_UPDATE_REQUEST: false,
				VIEW_ALL_SUBSCRIPTIONS: false,
				EDIT_ALL_SUBSCRIPTIONS: false,
				CANCEL_ALL_SUBSCRIPTIONS: false,
				CREATE_SUBSCRIPTION_COUPONS: false,
				VIEW_SUBSCRIPTION_COUPONS: false,
				DELETE_SUBSCRIPTION_COUPONS: false,
				CREATE_SUBSCRIPTION_FEATURES: false,
				VIEW_SUBSCRIPTION_FEATURES: false,
				EDIT_SUBSCRIPTION_FEATURES: false,
				DELETE_SUBSCRIPTION_FEATURES: false,
				CREATE_SUBSCRIPTION_BUNDLES: false,
				VIEW_SUBSCRIPTION_BUNDLES: false,
				EDIT_SUBSCRIPTION_BUNDLES: false,
				DELETE_SUBSCRIPTION_BUNDLES: false,
				VIEW_SUBSCRIPTION_PRICINGS: false,
				CREATE_SUBSCRIPTION_PRICINGS: false,
				EDIT_SUBSCRIPTION_PRICINGS: false,
				DELETE_SUBSCRIPTION_PRICINGS: false,
				VIEW_ALL_ORDERS: false,
				HAVE_UNLIMITED_STORES: false,
				CRAWLER: false,
				VIEW_SERVER_STATS: false,
				EDIT_ALL_AGENCIES: false,
				SELL_PRODUCTS: false,
				CHANGE_STORE_OWNER: false,
				ADD_STORE_USER: false,
				REMOVE_STORE_USER: false,
				CHANGE_USER_STORE_ROLE: false,
				VIEW_ALL_AGENCY_USERS: false,
				VIEW_STORE_USERS: false,
				VIEW_AGENCY_STORES: false,
				EDIT_AGENCY_STORES: false,
				VIEW_AGENCY_USERS: false,
				EDIT_AGENCY_USERS: false,
				VIEW_AGENCY_USER_REQUESTS: false,
				EDIT_AGENCY_USER_REQUESTS: false
            },
			StorePermission: {
            	VIEW: 'VIEW',
	DISABLE: 'DISABLE',
	ENABLE: 'ENABLE',
	DELETE: 'DELETE',
	EDIT_BASIC: 'EDIT_BASIC',
	EDIT_OPENING_HOURS: 'EDIT_OPENING_HOURS',
	EDIT_LOGO: 'EDIT_LOGO',
	EDIT_IMAGES: 'EDIT_IMAGES',
	EDIT_SOCIAL_MEDIA: 'EDIT_SOCIAL_MEDIA',
	EDIT_PARKING: 'EDIT_PARKING',
	EDIT_PAYMENT_METHODS: 'EDIT_PAYMENT_METHODS',
	EDIT_BRANDS: 'EDIT_BRANDS',
	EDIT_GASTRO_BASIC: 'EDIT_GASTRO_BASIC',
	EDIT_GASTRO_MENU: 'EDIT_GASTRO_MENU',
	EDIT_STADTGELD: 'EDIT_STADTGELD',
	EDIT_ARTICLES: 'EDIT_ARTICLES',
	VIEW_USERS: 'VIEW_USERS',
	ADD_USER: 'ADD_USER',
	REMOVE_USER: 'REMOVE_USER',
	CHANGE_USER_ROLE: 'CHANGE_USER_ROLE',
	CHANGE_OWNER: 'CHANGE_OWNER',
	VIEW_ROLES: 'VIEW_ROLES',
	CREATE_ROLE: 'CREATE_ROLE',
	EDIT_ROLE: 'EDIT_ROLE',
	DELETE_ROLE: 'DELETE_ROLE',
	ASSIGN_ROLE: 'ASSIGN_ROLE',
	VIEW_ORDER_SPLIT: 'VIEW_ORDER_SPLIT',
	VIEW_SALES_STORES: 'VIEW_SALES_STORES',
	EDIT_SALES_SETTINGS: 'EDIT_SALES_SETTINGS',
	VIEW_SALES: 'VIEW_SALES',
	VIEW_RESERVATIONS: 'VIEW_RESERVATIONS',
	UPDATE_RESERVATION_STATUS: 'UPDATE_RESERVATION_STATUS',
	EDIT_RESERVATION_SETTINGS: 'EDIT_RESERVATION_SETTINGS',
	VIEW_APPOINTMENT_REQUESTS: 'VIEW_APPOINTMENT_REQUESTS',
	EDIT_APPOINTMENT_REQUEST_SETTINGS: 'EDIT_APPOINTMENT_REQUEST_SETTINGS',
	ACCEPT_APPOINTMENT_REQUEST: 'ACCEPT_APPOINTMENT_REQUEST',
	REJECT_APPOINTMENT_REQUEST: 'REJECT_APPOINTMENT_REQUEST',
	VIEW_REPORTS: 'VIEW_REPORTS',
	VIEW_ARTICLES: 'VIEW_ARTICLES',
	ADD_ARTICLE: 'ADD_ARTICLE',
	EDIT_STOCK_ITEMS: 'EDIT_STOCK_ITEMS',
	VIEW_SELECTED_OFFER_CAMPAIGNS: 'VIEW_SELECTED_OFFER_CAMPAIGNS',
	CREATE_SELECTED_OFFER_CAMPAIGNS: 'CREATE_SELECTED_OFFER_CAMPAIGNS',
	EDIT_SELECTED_OFFER_CAMPAIGNS: 'EDIT_SELECTED_OFFER_CAMPAIGNS',
	DELETE_SELECTED_OFFER_CAMPAIGNS: 'DELETE_SELECTED_OFFER_CAMPAIGNS',
	USE_EMBEDDABLES_EDITOR: 'USE_EMBEDDABLES_EDITOR',
	VIEW_EMBEDDABLE_TEMPLATES: 'VIEW_EMBEDDABLE_TEMPLATES',
	CREATE_EMBEDDABLE_TEMPLATES: 'CREATE_EMBEDDABLE_TEMPLATES',
	EDIT_EMBEDDABLE_TEMPLATES: 'EDIT_EMBEDDABLE_TEMPLATES',
	DELETE_EMBEDDABLE_TEMPLATES: 'DELETE_EMBEDDABLE_TEMPLATES',
	ENABLE_INTEGRATION: 'ENABLE_INTEGRATION',
	DISABLE_INTEGRATION: 'DISABLE_INTEGRATION',
	VIEW_ORDERS: 'VIEW_ORDERS',
	PROCESS_ORDERS: 'PROCESS_ORDERS',
	REFUND_ORDERS: 'REFUND_ORDERS'
            }
        };
    },
    methods: {
        'requestStorePermissions': requestStorePermissions,
        'can': can,
        hasStorePermission(storeUuid, permission) {
            return this.StorePermission.hasOwnProperty(storeUuid) && this.StorePermission[storeUuid].includes(permission);
        }
    },
    beforeMount() {
        if (this.$page.props.user_permissions) {
            for (let usersPermission of this.$page.props.user_permissions) {
                this.Permission[usersPermission] = true;
            }
        } else {
            console.warn("Missing user permissions.");
        }
        if (this.$page.props.store_permissions) {
            for (let storeUuid in this.$page.props.store_permissions) {
                this.StorePermission[storeUuid] = this.$page.props.store_permissions[storeUuid];
            }
        }
    }
};